import React from 'react';
import {Container} from "reactstrap";
import UserAccessesList from "../../../components/ManageUsers/UserAccessesList";
import {TableFiltersProvider} from "../../../context/table_filters/TableFiltersIndex";

const UserAccessesView = () => {
  return (
    <Container fluid className={'mt-5'}>
      <TableFiltersProvider>
        <UserAccessesList/>
      </TableFiltersProvider>
    </Container>
  );
};

export default UserAccessesView;
